// @ts-nocheck
import { useContext } from 'react';
import { DialogContext } from '../providers';

const useDialog = () => useContext(DialogContext);

export default useDialog;
